import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxReportDetailsComponent } from '../../tax-report-details/feature-tax-report-details.component';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-kosten-uitbesteed-werk',
  templateUrl: './spec-kosten-uitbesteed-werk.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    CommonModule
  ],
  styleUrls: ['./spec-kosten-uitbesteed-werk.component.css']
})
export class SpecKostenUitbesteedWerkComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public costsOutsourcedWorkOtherExternalExpensesFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.costsOutsourcedWorkOtherExternalExpensesFg = this.jrDataService.createFormGroupBalanceItem();
  }

  private patchData(value: JaarrapportageEntity) {
    const kostenUitbesteedWerk = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.kostenUitbesteedWerk;
    if (kostenUitbesteedWerk?.costsOutsourcedWorkOtherExternalExpenses) {
        const subItem = kostenUitbesteedWerk.costsOutsourcedWorkOtherExternalExpenses;
        this.costsOutsourcedWorkOtherExternalExpensesFg.patchValue(subItem)
        this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.costsOutsourcedWorkOtherExternalExpensesFg.get('trialBalanceItems') as FormArray)
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });

    this.costsOutsourcedWorkOtherExternalExpensesFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          kostenUitbesteedWerk: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.kostenUitbesteedWerk,
            costsOutsourcedWorkOtherExternalExpenses: this.costsOutsourcedWorkOtherExternalExpensesFg.value
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity);
  }
}
